if (!customElements.get('infinite-pagination')) {
    customElements.define('infinite-pagination', class InfinitePagination extends HTMLElement {
        constructor() {
            super();
            let _this = this;
            this.currentPage = parseInt(this.dataset.currentPage)
            this.maxPage = parseInt(this.dataset.maxPage)
            this.nextPageUrl = this.dataset.nextPageUrl
            this.section = this.dataset.section
            this.button = this.querySelector('button');
            if(this.button){
				this.button.addEventListener('click',_this.loadProducts.bind(_this));
			}


        }

        loadProducts(event){
			if(this.button){
				this.button.classList.add('loading')
			}
            event.preventDefault();
            fetch(this.nextPageUrl + `&section_id=${this.section}`)
                .then((response) => response.text())
                .then((html) => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const fetchProductGrid = doc.querySelector('[data-product-grid] .collection-product-grid');
                    const fetchPagination = doc.querySelector('[data-pagination]');
                    const productGrid = document.querySelector('[data-product-grid] .collection-product-grid');
                    const pagination = document.querySelector('[data-pagination]');

                    if(fetchProductGrid && productGrid){
                        productGrid.insertAdjacentHTML('beforeend',fetchProductGrid.innerHTML)
                    }
                    if(fetchPagination && pagination){
                        pagination.outerHTML = fetchPagination.outerHTML
                    }

					if (window.lazyLoadEnabled == "true") {
						reloadLazyLoad();
					}
                    setTimeout(function (){
						reloadProductCardHover();
                    },500)
                    // window.history.replaceState({ }, '', this.nextPageUrl);

                })
                .catch((error) => {
                    console.log(error);
                });
        }
    });
}
